import React from "react";

function Icon({ className = null, seasonColor, id = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="280"
      viewBox="0 0 200 280"
      preserveAspectRatio="none"
      className={className}
    >
      <defs>
        <clipPath id={`${id}-clip-path-3`}>
          <path
            fill="#fff"
            d="M0 0H200V280H0z"
            data-name="Rectangle 1798"
            transform="translate(-8903 -11193)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(#${id}-clip-path-3)`}
        data-name="Groupe de masques 64"
        transform="translate(8903 11193)"
      >
        <g data-name="Groupe 11593" transform="translate(-9002.749 -11272.344)">
          <path
            fill="#06ae5c"
            d="M0 184.732v24.386c115.322 0 210.086-91.756 220.955-209.118C93.645 22.06 0 96.408 0 184.732"
            data-name="Tracé 2675"
            transform="translate(129.542 264.166)"
          ></path>
          <path
            fill={seasonColor}
            d="M0 161.237v21.285c100.655 0 183.367-80.086 192.853-182.522C81.735 19.254 0 84.147 0 161.237"
            data-name="Tracé 2676"
            transform="rotate(83 -38.581 216.655)"
          ></path>
          <path
            fill="#e0c6a2"
            d="M0 135.6v17.9c84.65 0 154.209-67.353 162.187-153.5C68.738 16.193 0 70.766 0 135.6"
            data-name="Tracé 2677"
            transform="translate(32.549)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
